import React, { Component } from 'react';
import { connect } from 'react-redux'
import { DragDropContext } from 'react-dnd';
import TouchBackend from 'react-dnd-touch-backend';
import ObjectItemButton from './ObjectItemButton'
import ObjectItemDropTarget from './ObjectItemDropTarget'
import ObjectItemDragLayer from './ObjectItemDragLayer'

class ObjectItemOverview extends Component {
    render() {
        const {
            objectgroups,
            selectedobjectgroup,
            posId
        } = this.props;

        const objectGroup = selectedobjectgroup ? objectgroups.find(g => g.ObjectGroupId === selectedobjectgroup) : null;
        if (!objectGroup) return null;

        const datagrid = {
            x: objectGroup.GridX,
            y: objectGroup.GridY
        }
        const objectItems = objectGroup.ObjectItems;

        const defaultbtnwidth = 100.0 / datagrid.x
        const defaultbtnheight = 100.0 / datagrid.y

        return (
            <div id="om_overview">
                <ObjectItemDropTarget
                    rasterX={datagrid.x}
                    rasterY={datagrid.y}>
                    {
                        objectItems.map(objectItem => {
                            return (objectItem.Show === undefined || objectItem.Show) &&
                            <ObjectItemButton
                                key={objectItem.ObjectItemId}
                                id={objectItem.ObjectItemId}
                                text={objectItem.Description}
                                capacity={objectItem.Capacity}
                                btnheight={defaultbtnheight * objectItem.Height}
                                btnwidth={defaultbtnwidth * objectItem.Width}
                                btntop={(defaultbtnheight * (objectItem.LocationY + 1)) - defaultbtnheight}
                                btnleft={(defaultbtnwidth * (objectItem.LocationX + 1)) - defaultbtnwidth}
                                number={objectItem.ItemNumber}
                                itemtype={objectItem.ItemType}
                                receiptnumber={objectItem.ReceiptNumber}
                                objectgroupid={objectItem.ObjectGroupId}
                                receiptdatetime={objectItem.ReceiptDateTime}
                                locked={objectItem.Locked}
                                userLocked={objectItem.LockedByUser}
                                processed={!(objectItem.ProductionPosIds && objectItem.ProductionPosIds.split(';').includes(posId.toString()))}
                                customer={objectItem.Customer}
                            />
                        }
                        )
                    }
                </ObjectItemDropTarget>
                <ObjectItemDragLayer />
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        objectgroups: state.objectManagementState.objectgroups,
        selectedobjectgroup: state.objectManagementState.selectedobjectgroup,
        posId: state.generalState.posId
    }
}

ObjectItemOverview = DragDropContext(TouchBackend({ enableMouseEvents: true }))(ObjectItemOverview);
export default connect(mapStateToProps)(ObjectItemOverview)


// WEBPACK FOOTER //
// src/objectmanagement/components/ObjectItemOverview.jsx